import { render, staticRenderFns } from "./PrintOrX.vue?vue&type=template&id=09c90c7e"
import script from "./PrintOrX.vue?vue&type=script&lang=ts"
export * from "./PrintOrX.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports